import React from "react";
import "../styles/ConnectionErrorModal.css";
import {useTheme} from '../providers/ThemeProvider';


interface ConnectionErrorModalProps {
    isOpen: boolean;
    onRetry: () => void;
    onCancel: () => void;
}

const ConnectionErrorModal: React.FC<ConnectionErrorModalProps> = ({ onRetry, onCancel, isOpen }) => {
    const {theme} = useTheme();
    if (!isOpen) return null;
    return (
        <div className="modal-overlay">
            <div className="resume-modal">
                <h2 className="modal-title-connection"
                    dangerouslySetInnerHTML={{__html: theme?.content.connectionErrorModal.title || ''}}></h2>
                <p className="modal-text-connection">
                    {theme?.content.connectionErrorModal.messagePart1}
                    <br/>
                    {theme?.content.connectionErrorModal.messagePart2}
                </p>
                <p className="modal-text-connection">
                    {theme?.content.connectionErrorModal.message2}
                </p>
                <div className="modal-actions">
                    <button className="btn btn-secondary cancel-button "
                            onClick={onCancel}>{theme?.content.connectionErrorModal.cancelButton}</button>
                    <button className="btn retry-button" onClick={onRetry}
                            title="Te llevaremos a la pantalla de inicio para volver a intentarlo"
                    >Intentar de nuevo</button>
                </div>
            </div>
        </div>
    );
};

export default ConnectionErrorModal;
